import LoginLogoutActions from './LoginLogoutAction';
import GeneralBucket from './GeneralBucketAction';
import Home from './HomeActions';
import KnowledgeCenter from './KnowledgeCednterActions';
import webSocketFunc  from './WebSocketAction';
import ModalPopup from './ModalPopupAction';
import Notification from './NotificationAction';
import RecSessionBucket from './RecSessionBucketActions';
import TopicData from './TopicBucketAction';

const allActions = {
    GeneralBucket,
    LoginLogoutActions,
    Home,
    KnowledgeCenter,
    webSocketFunc,
    ModalPopup,
    Notification,
    RecSessionBucket,
    TopicData
}

export default allActions